<div class="days">
  @for (day of days$|async; track day.dayDate) {
  <planner-day [day]="day"></planner-day>
  }
</div>
